export default __webpack_public_path__ + "static/media/metal-mask.6ecb2272.svg";